import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditorComponent = ({ value = '', onChange }) => {
  const [lastEdited, setLastEdited] = useState(new Date());

  const onChangeEditor = (content) => {
    if (onChange) {
      onChange(content);
    }

    setLastEdited(new Date());
  };

  const getWordCount = (htmlContent) => {
    const text = htmlContent.replace(/<[^>]*>/g, ' ');
    return text.trim().split(/\s+/).filter(Boolean).length;
  };

  const wordCount = getWordCount(value);

  const formatLastEdited = (date) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${month} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      ['clean'],
    ],
  };

  return (
    <div
      style={{
        border: '1px solid #ddd',
        borderRadius: '4px',
        backgroundColor: '#fff',
        marginBottom: '24px',
      }}
    >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChangeEditor}
        modules={modules}
        style={{
          minHeight: '300px',
        }}
      />
      <style>
        {`
  .ql-editor {
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
  }
`}
      </style>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 16px',
          borderTop: '1px solid #ddd',
          fontSize: '13px',
          color: '#666',
        }}
      >
        <span>Word count: {wordCount}</span>
        <span>Last edited on {formatLastEdited(lastEdited)}</span>
      </div>
    </div>
  );
};

export default EditorComponent;
